
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5292',
  depVersions: {
  "data-privacy-request-ui": "static-1.5292",
  "data-fetching-client": "static-1.9444",
  "head-dlb": "static-1.4754",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7773",
  "hub-http-shared-msw-handlers": "static-1.9393",
  "hubspot-dlb": "static-2.1796",
  "HubStyleTokens": "static-2.11187",
  "I18n": "static-7.1561",
  "jasmine-runner": "static-1.6241",
  "privacy-center-public-service-types": "static-1.4555",
  "quartz": "static-1.6683",
  "react-dlb": "static-1.71",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5325",
  "UIComponents": "static-3.8134",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.81",
  "foundations-assets": "static-1.4599",
  "foundations-components": "static-1.7458",
  "foundations-components-test-utils": "static-1.4941",
  "foundations-theming": "static-1.4175",
  "hub-http": "static-1.5966",
  "quartz-config": "static-1.461",
  "quartz-core": "static-1.5902",
  "quick-fetch": "static-1.3703",
  "raven": "static-3.5624",
  "react": "static-7.177",
  "react-rhumb": "static-1.16408",
  "SharedI18nStrings": "static-1.180",
  "ui-addon-i18n": "static-1.10899",
  "usage-tracker": "static-1.7101",
  "usage-tracker-anonymous": "static-1.5518",
  "usage-tracker-core": "static-1.6951",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3917",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3195",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2960",
  "quartz-webpack": "static-1.2907",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.77",
  "HeadJS": "static-2.703",
  "framer-motion": "static-1.67",
  "hs-test-utils-bend-plugin": "static-1.2884",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "ts-schema": "static-1.3874",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "react-utils": "static-2.5144",
  "StyleGuideUI": "static-3.483",
  "jasmine": "static-4.4098",
  "rpc-client-utils": "static-1.4399",
  "HubStyle": "static-2.11495",
  "ui-addon-draggable": "static-3.4533",
  "cssUtils": "static-1.723",
  "hs-story-utils": "static-1.9195",
  "icons": "static-2.618",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.94",
  "ui-images": "static-2.1083",
  "bend-plugin-foundations-components": "static-1.3727",
  "floating-ui": "static-1.51",
  "foundations-theming-specialty": "static-1.1891",
  "react-aria": "static-1.61",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1099",
  "ui-fonts": "static-1.449",
  "bend-plugin-foundations-theming": "static-1.2658",
  "foundations-theming-base": "static-1.3160",
  "stylex": "static-1.27",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.786",
  "hubspotter-http": "static-1.4448",
  "mobile-manifest-mixins": "static-1.476",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.358",
  "quartz-head": "static-1.348",
  "quartz-i18n": "static-1.358",
  "quartz-routing": "static-1.113",
  "quartz-test": "static-1.358",
  "usage-tracker-container": "static-1.7091",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.2903",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.65",
  "sassPrefix": "static-1.151",
  "hubspotter-http-shared-msw-handlers": "static-1.9391"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5292",
  "data-fetching-client": "/data-fetching-client/static-1.9444",
  "head-dlb": "/head-dlb/static-1.4754",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7773",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9393",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "HubStyleTokens": "/HubStyleTokens/static-2.11187",
  "I18n": "/I18n/static-7.1561",
  "jasmine-runner": "/jasmine-runner/static-1.6241",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4555",
  "quartz": "/quartz/static-1.6683",
  "react-dlb": "/react-dlb/static-1.71",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5325",
  "UIComponents": "/UIComponents/static-3.8134",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
  "foundations-assets": "/foundations-assets/static-1.4599",
  "foundations-components": "/foundations-components/static-1.7458",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4941",
  "foundations-theming": "/foundations-theming/static-1.4175",
  "hub-http": "/hub-http/static-1.5966",
  "quartz-config": "/quartz-config/static-1.461",
  "quartz-core": "/quartz-core/static-1.5902",
  "quick-fetch": "/quick-fetch/static-1.3703",
  "raven": "/raven/static-3.5624",
  "react": "/react/static-7.177",
  "react-rhumb": "/react-rhumb/static-1.16408",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10899",
  "usage-tracker": "/usage-tracker/static-1.7101",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5518",
  "usage-tracker-core": "/usage-tracker-core/static-1.6951",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3195",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2960",
  "quartz-webpack": "/quartz-webpack/static-1.2907",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.77",
  "HeadJS": "/HeadJS/static-2.703",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2884",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "ts-schema": "/ts-schema/static-1.3874",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "react-utils": "/react-utils/static-2.5144",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "jasmine": "/jasmine/static-4.4098",
  "rpc-client-utils": "/rpc-client-utils/static-1.4399",
  "HubStyle": "/HubStyle/static-2.11495",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4533",
  "cssUtils": "/cssUtils/static-1.723",
  "hs-story-utils": "/hs-story-utils/static-1.9195",
  "icons": "/icons/static-2.618",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.94",
  "ui-images": "/ui-images/static-2.1083",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3727",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1891",
  "react-aria": "/react-aria/static-1.61",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1099",
  "ui-fonts": "/ui-fonts/static-1.449",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2658",
  "foundations-theming-base": "/foundations-theming-base/static-1.3160",
  "stylex": "/stylex/static-1.27",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.786",
  "hubspotter-http": "/hubspotter-http/static-1.4448",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.476",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.358",
  "quartz-head": "/quartz-head/static-1.348",
  "quartz-i18n": "/quartz-i18n/static-1.358",
  "quartz-routing": "/quartz-routing/static-1.113",
  "quartz-test": "/quartz-test/static-1.358",
  "usage-tracker-container": "/usage-tracker-container/static-1.7091",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.2903",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.65",
  "sassPrefix": "/sassPrefix/static-1.151",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9391"
}
};
